import { Analytics } from '@cobliteam/analytics';
import { useTranslation } from '@cobliteam/i18n';
import Button from '@cobliteam/ui/components/Button';

interface ChecklistStepActionProps {
  fleetId?: string;
  /** Opens the checklist drawer (hosted by the parent so the guide modal can slide aside). */
  onCreate: () => void;
}

/** Footer button that opens the checklist drawer; the drawer itself is hosted by the parent. */
const ChecklistStepAction = ({ fleetId, onCreate }: ChecklistStepActionProps) => {
  const { t } = useTranslation('basic-value-onboarding');

  const handleOpen = () => {
    Analytics.track('BasicValueModalItemCreated', { fleetId, feature: 'checklists' });
    onCreate();
  };

  return <Button onClick={handleOpen}>{t('features.checklists.cta')}</Button>;
};

export default ChecklistStepAction;
